import { pdpaApi } from "@api";
import { PATH_PRIVACY_MANAGEMENT } from "@configs";
import { IPdpa } from "@interfaces";
import { setLoading } from "@redux";
import { newFormatMessage, useNotify } from "@utils";
import { Switch } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

interface IProps {
    item: IPdpa;
    callback: () => void;
}
export const ComponentPrivacy = (props: IProps) => {
    const { item, callback } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { error, success } = useNotify();
    const handleChange = async (status: boolean) => {
        try {
            dispatch(setLoading(true));
            const res = await pdpaApi.postPdpaToAccept({
                pdpaId: item.pdpaId,
                isAccept: status,
            });
            if (res.data.error === "0") {
                callback();
                dispatch(setLoading(false));
                success(newFormatMessage(res));
            } else {
                error(newFormatMessage(res));
            }
        } catch (err: any) {
            dispatch(setLoading(false));
        }
    };
    return (
        <div className="consent-item">
            <p>
                {t("page.allow_for")}{" "}
                <Link to={`${PATH_PRIVACY_MANAGEMENT}/${item._id}`}>{item.nameForm}</Link>
            </p>
            <Switch onChange={handleChange} checked={item.isAccept}></Switch>
        </div>
    );
};
